import { render, staticRenderFns } from "./ProfitPoolSettings.vue?vue&type=template&id=07c2c15b"
import script from "./ProfitPoolSettings.vue?vue&type=script&lang=js"
export * from "./ProfitPoolSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports